// // config.js
// const baseUrl = process.env.NODE_ENV === 'development'
//   ? 'http://localhost:5000/api'
//   : 'http://localhost:5000/api';

// export default baseUrl;



// const baseUrl = process.env.NODE_ENV === 'development'
//   ? 'http://localhost:5000/api'
//   : 'https://psekaran.com/api';


//   export default baseUrl;




// const baseUrl = process.env.NODE_ENV === 'development'
//   ? 'http://109.236.89.55:3000/api'
//   : 'http://109.236.89.55:3000/api';


//   export default baseUrl;



// const baseUrl = process.env.NODE_ENV === 'Development'
//   ? 'http://localhost:5000/elixiapi'
//   : 'https://psekaran.com/elixiapi';

console.log("NODE_ENV:", process.env.NODE_ENV);

//   export default baseUrl;
const baseUrl = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5000/elixiapi'
  : 'https://psekaran.com/elixiapi';




  export default baseUrl;